import { BigBashEvent, GamePoint, RoundPoint } from "@/types/types";

export function mergeGamePointsForGame(event: BigBashEvent, gameId: string, updatedGamePoints: GamePoint[]): GamePoint[] {
	const otherGamesPoints = event.game_points.filter(gamePoint => gamePoint.game !== gameId);
	return [...otherGamesPoints, ...updatedGamePoints];
}

export function getFocusedTeamId(composedPath: EventTarget[]): string | null {
	for (const node of composedPath) {
		if (node instanceof HTMLElement && node.dataset.teamId) {
			return node.dataset.teamId;
		}
	}
	return null;
}

export function getTeamIdWithGamePointUpdate(previousGamePoints: GamePoint[], updatedGamePoints: GamePoint[], gameId: string): string[] {
	const previousGamePointByTeam = new Map(
		previousGamePoints.filter(gamePoint => gamePoint.game === gameId).map(gamePoint => [gamePoint.team, gamePoint])
	);

	return updatedGamePoints
		.filter(gamePoint => gamePoint.game === gameId)
		.filter(updatedGamePoint => {
			const previousGamePoint = previousGamePointByTeam.get(updatedGamePoint.team);
			return !previousGamePoint || haveRoundsChanged(previousGamePoint.rounds, updatedGamePoint.rounds);
		})
		.map(gamePoint => gamePoint.team);
}

function haveRoundsChanged(previousRounds: RoundPoint[], updatedRounds: RoundPoint[]): boolean {
	if (previousRounds.length !== updatedRounds.length) {
		return true;
	}
	return updatedRounds.some(updatedRound => {
		const previousRound = previousRounds.find(round => round.round === updatedRound.round);
		if (!previousRound) {
			return true;
		}
		return previousRound.points !== updatedRound.points
			|| previousRound.team_fastest_time_seconds !== updatedRound.team_fastest_time_seconds
			|| previousRound.team_smallest_difference_value !== updatedRound.team_smallest_difference_value
			|| previousRound.round_target_value !== updatedRound.round_target_value;
	});
}
